import React from "react"; // eslint-disable-line no-unused-vars
import { Modal, ModalBody } from "reactstrap";
import InputGroup from "../forms/InputGroup";
import { validateField, submitForm } from "../pages/functions";
import moment from "moment";
import approve from "approvejs";
import Datetime from "react-datetime";
import Select from "../forms/Select";
import { api } from "./index.api";
import { connect } from "react-redux";
import { addNotification as notify } from "reapop";
import { CircularProgress } from "@material-ui/core";
import { getCookie } from "../helpers/CookieHandler";
import { getApplicationSiteKey, getApplicationRegex } from "./plugins/utils";

const DATE_FORMAT = "MMMM D, YYYY";
const CONTACT_OPTIONS = [
  { value: "Email", label: "Email" },
  { value: "Phone", label: "Phone" },
];
const TIME_OPTIONS = [
  { value: "Early Morning", label: "Early Morning" },
  { value: "Morning", label: "Morning" },
  { value: "Afternoon", label: "Afternoon" },
  { value: "Any Time", label: "Any Time" },
];

class FindMyMSLMeetingRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: {
        firstName: {
          value: "",
          rules: {
            title: "First name",
            required: { required: true },
          },
        },
        lastName: {
          value: "",
          rules: {
            title: "Last name",
            required: { required: true },
          },
        },
        institutionName: {
          value: "",
          rules: {
            title: "Institution name",
            required: { required: true },
          },
        },
        email: {
          value: "",
          rules: {
            title: "Email",
            email: true,
            required: { required: true },
          },
        },
        phoneNumber: {
          value: "",
          rules: {
            title: "Phone number",
            phone: true,
            required: { required: true },
          },
        },
        addressOne: {
          value: "",
          rules: {
            title: "Address line 1",
          },
        },
        addressTwo: {
          value: "",
          rules: {
            title: "Address line 2",
          },
        },
        city: {
          value: "",
          rules: {
            title: "City",
          },
        },
        state: {
          value: "",
          rules: {
            title: "State",
          },
        },
        zipCode: {
          value: "",
          rules: {
            title: "Zip code",
            numeric: true,
            ignoreNull: true,
          },
        },
        preferredDate: {
          value: "",
          rules: {
            title: "Preferred date",
            required: { required: true },
          },
        },
        preferredContactMethod: {
          value: "",
          name: "preferredContactMethod",
          rules: {
            title: "Preferred method of contact",
            required: { required: true },
          },
        },
        preferredTimeOfDay: {
          value: "",
          name: "preferredTimeOfDay",
          rules: {
            title: "Preferred time of day",
            required: { required: true },
          },
        },
      },
      certChecked: false,
      certError: false,
      isSubmitting: false,
    };
  }

  validate(e, field) {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = this.props.referenceData;
    const regex = getApplicationRegex(ref_Data);
    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      // Emoji detected, prevent it from being added
      this.props._showNotification(
        "Error!",
        "Special characters are not allowed",
        "error"
      );
      return;
    } else if (
      regex.Script_Regex !== null &&
      regex.Script_Regex.test(inputValue)
    ) {
      // HTML Tags and Script detected, prevent it from being added
      this.props._showNotification(
        "Error!",
        "Submission fails. Input contains prohibited words. Please remove them and try again.",
        "error"
      );
      return;
    } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
      this.props._showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return;
    }
    const fields = validateField(e, field, this.state.fields);
    this.setState({ fields });
  }

  onDateChange = (momentValue, field) => {
    if (!moment.isMoment(momentValue)) {
      return;
    }
    const date = momentValue.format(DATE_FORMAT);
    field.value = date;
    field.errors = [];
    const result = approve.value(date, field.rules);
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors);
    }

    this.setState({
      fields: this.state.fields,
    });
  };

  onCalendarKeydown = (event, closeCalendar) => {
    if (event.key === "Enter") {
      event.preventDefault();
      closeCalendar();
      const field = this.state.fields.preferredDate;
      if (!field.value) {
        const today = moment().startOf("day");
        this.onDateChange(today, field);
      }
    } else if (event.key === "Tab") {
      closeCalendar();
    }
  };

  isValidDate = (date, today) => date.isSameOrAfter(today, "day");

  handleCertChange = () =>
    this.setState({
      certChecked: !this.state.certChecked,
      certError: false,
    });

  submit = (e) => {
    e.preventDefault();
    const fields = submitForm(e, this.state.fields);
    this.setState({
      fields,
      certError: !this.state.certChecked,
    });

    if (!this.state.certChecked) {
      return;
    }
    for (const key in fields) {
      if (fields[key].errors.length > 0) {
        return;
      }
    }

    this.setState({ isSubmitting: true });
    let searchFormFields;
    if (this.props.searchFormFields && this.props.searchFormFields.current) {
      searchFormFields =
        this.props.searchFormFields.current.getWrappedInstance().state.fields;
    } else {
      searchFormFields = {
        therapeuticArea: { value: "" },
        subTherapeuticArea: { value: "" },
        diseaseState: { value: "" },
      };
    }
    const requestBody = {
      firstName: this.state.fields.firstName.value,
      lastName: this.state.fields.lastName.value,
      institutionName: this.state.fields.institutionName.value,
      email: this.state.fields.email.value,
      phoneNumber: this.state.fields.phoneNumber.value,
      preferredDate: this.state.fields.preferredDate.value,
      preferredTimeOfDay: this.state.fields.preferredTimeOfDay.value,
      address1: this.state.fields.addressOne.value,
      address2: this.state.fields.addressTwo.value,
      city: this.state.fields.city.value,
      state: this.state.fields.state.value,
      postalCode: this.state.fields.zipCode.value,
      methodOfContact: this.state.fields.preferredContactMethod.value,
      certification: this.state.certChecked,
      mslEmail: this.props.msl.email_address,
      mslFirstName: this.props.msl.firstName,
      mslLastName: this.props.msl.lastName,
      mslId: this.props.msl.id,
      therapeuticArea: searchFormFields.therapeuticArea.value,
      subTherapeuticArea: searchFormFields.subTherapeuticArea.value,
      diseaseState: searchFormFields.diseaseState.value,
      fingerprint: getCookie("_hash"),
    };
    const ref_Data = this.props.referenceData;
    const SITE_KEY = getApplicationSiteKey(ref_Data);

    if (SITE_KEY) {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(SITE_KEY, { action: "SUBMIT_MSL_MEETING_REQUEST" })
          .then((token) => {
            const queryParams = { token: token };
            api.mslMeetingRequest(
              queryParams,
              requestBody,
              this.onSubmitSuccess,
              this.onSubmitFailure
            );
          })
          .catch(() => {
            this.props.notify({
              title: "Error!",
              message: "CAPTCHA verification failed. Please try again.",
              status: "error",
              position: "tr",
              dismissible: true,
              dismissAfter: 5000,
            });
            this.setState({ isSubmitting: false });
          });
      });
    } else {
      this.props.notify({
        title: "Error!",
        message: "CAPTCHA configuration is missing. Please contact support.",
        status: "error",
        position: "tr",
        dismissible: true,
        dismissAfter: 5000,
      });
      this.setState({ isSubmitting: false });
    }
  };

  onSubmitSuccess = (response) => {
    if (!response.ok) {
      this.onSubmitFailure();
      return;
    }
    this.props.onSubmitted();
    this.props.onClose();
  };

  onSubmitFailure = () => {
    this.props.notify({
      title: "Error",
      message:
        "There seems to be an error at our server side. Please try again later.",
      status: "error",
      position: "tr",
      dismissible: true,
      dismissAfter: 5000,
    });
    this.setState({ isSubmitting: false });
  };

  render() {
    const { isOpen, onClose, msl } = this.props;
    return (
      <div>
        <Modal isOpen={isOpen} wrapClassName="modal-primary" size="lg">
          <div className="modal-title-color findmymsl-modal-title">
            <h5>
              <strong>Request a Meeting with a Medical Science Liaison </strong>
            </h5>
            <h6>{`Please fill out the request form below to connect with ${msl.firstName} ${msl.lastName}`}</h6>
          </div>
          <ModalBody>
            <div id="findmymsl-modal-body" className="findmymsl-modal-body">
              <form onSubmit={this.submit}>
                <div className="row">
                  <div
                    id="firstname"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 1 }}
                  >
                    <InputGroup
                      field={this.state.fields.firstName}
                      validate={(e) =>
                        this.validate(e, this.state.fields.firstName)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="address1"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 6 }}
                  >
                    <InputGroup
                      field={this.state.fields.addressOne}
                      validate={(e) =>
                        this.validate(e, this.state.fields.addressOne)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="lastname"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 2 }}
                  >
                    <InputGroup
                      field={this.state.fields.lastName}
                      validate={(e) =>
                        this.validate(e, this.state.fields.lastName)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="address2"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 7 }}
                  >
                    <InputGroup
                      field={this.state.fields.addressTwo}
                      validate={(e) =>
                        this.validate(e, this.state.fields.addressTwo)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="institution"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 3 }}
                  >
                    <InputGroup
                      field={this.state.fields.institutionName}
                      validate={(e) =>
                        this.validate(e, this.state.fields.institutionName)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="city"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 8 }}
                  >
                    <InputGroup
                      field={this.state.fields.city}
                      validate={(e) => this.validate(e, this.state.fields.city)}
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="email"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 4 }}
                  >
                    <InputGroup
                      field={this.state.fields.email}
                      validate={(e) =>
                        this.validate(e, this.state.fields.email)
                      }
                      type="email"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="state"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 9 }}
                  >
                    <InputGroup
                      field={this.state.fields.state}
                      validate={(e) =>
                        this.validate(e, this.state.fields.state)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="phone"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 5 }}
                  >
                    <InputGroup
                      field={this.state.fields.phoneNumber}
                      validate={(e) =>
                        this.validate(e, this.state.fields.phoneNumber)
                      }
                      type="tel"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                  <div
                    id="zipCode"
                    className="col-lg-6 m-b-15 ordered-field"
                    style={{ order: 10 }}
                  >
                    <InputGroup
                      field={this.state.fields.zipCode}
                      validate={(e) =>
                        this.validate(e, this.state.fields.zipCode)
                      }
                      type="text"
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                </div>

                <div className="row">
                  <div id="preferredDate" className="col-lg-6 m-b-15">
                    <Datetime
                      closeOnSelect
                      dateFormat={DATE_FORMAT}
                      timeFormat={false}
                      renderInput={(_props, openCalendar, closeCalendar) => (
                        <InputGroup
                          searchable={false}
                          clearable={false}
                          field={this.state.fields.preferredDate}
                          validate={() => true}
                          onFocus={
                            this.state.isSubmitting ? null : openCalendar
                          }
                          styles={{
                            backgroundColor: this.state.isSubmitting
                              ? "#eeeeee"
                              : "#ffffff",
                          }}
                          readonly
                          disabled={this.state.isSubmitting}
                          onKeyDown={(e) =>
                            this.onCalendarKeydown(e, closeCalendar)
                          }
                        />
                      )}
                      onChange={(moment) =>
                        this.onDateChange(
                          moment,
                          this.state.fields.preferredDate
                        )
                      }
                      isValidDate={(date) => this.isValidDate(date, moment())}
                    />
                  </div>
                  <div id="preferredMethod" className="col-lg-6 m-b-15">
                    <Select
                      searchable
                      clearable={false}
                      options={CONTACT_OPTIONS}
                      field={this.state.fields.preferredContactMethod}
                      validate={(e) =>
                        this.validate(
                          e,
                          this.state.fields.preferredContactMethod
                        )
                      }
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                </div>
                <div className="row">
                  <div id="preferredTime" className="col-lg-6">
                    <Select
                      searchable
                      clearable={false}
                      options={TIME_OPTIONS}
                      field={this.state.fields.preferredTimeOfDay}
                      validate={(e) =>
                        this.validate(e, this.state.fields.preferredTimeOfDay)
                      }
                      disabled={this.state.isSubmitting}
                    />
                  </div>
                </div>
                <div
                  className={
                    this.state.certError
                      ? "has-danger certification"
                      : "certification"
                  }
                >
                  <label className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={this.state.certChecked}
                      onChange={this.handleCertChange}
                      disabled={this.state.isSubmitting}
                    />
                    <span
                      id="certCheckbox"
                      className="custom-control-indicator"
                    />
                    <span className="custom-control-description">
                      I certify that I am an active healthcare professional with
                      a current license in the United States.
                    </span>
                  </label>
                </div>
                <div className="modal-buttons">
                  <button
                    id="msl-meeting-submit"
                    type="submit"
                    aria-label="Submit"
                    className="btn btn-info btn-lg-wide btn-rounded submit-button"
                    disabled={this.state.isSubmitting}
                  >
                    {this.state.isSubmitting ? (
                      <div className="loading-text-centered">
                        <span>Submit</span>
                        <span className="loading-progress-centered">
                          <CircularProgress size={24} />
                        </span>
                      </div>
                    ) : (
                      <React.Fragment>Submit</React.Fragment>
                    )}
                  </button>
                  <button
                    id="msl-meeting-cancel"
                    type="button"
                    aria-label="Cancel"
                    className="btn btn-primary reset-button hover btn-outline btn-lg-wide btn-rounded cancel-button"
                    onClick={onClose}
                    disabled={this.state.isSubmitting}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default connect(null, { notify })(FindMyMSLMeetingRequest);



// WEBPACK FOOTER //
// ./src/mi-app/FindMyMSLMeetingRequest.js